import React from 'react';

export default function ScorerLegend({ data, darkMode }) {
  const items = Array.isArray(data) ? data : [];

  return (
    <div className="space-y-3.5 min-w-[140px]">
      {items.map((item, index) => (
        <div key={`${item.name || 'segment'}-${index}`} className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-2.5">
            <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: item.color || '#6b7280' }}></div>
            <span className="text-sm text-gray-400 font-medium">{item.name || 'Unknown'} :</span>
          </div>
          <span className={`text-sm font-bold ${darkMode ? 'text-white' : 'text-gray-900'}`}>
            {item.name === 'No Bugs' || item.name === 'No Tests' ? '-' : Number(item.value) || 0}
          </span>
        </div>
      ))}
    </div>
  );
}